module.exports = __webpack_public_path__ + "img/30.f9a2e5d4.svg";